function ToggleIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='toggle-on-alt'>
        <path
          id='toggle-on-alt_2'
          d='M16 6H8C4.686 6 2 8.686 2 12C2 15.314 4.686 18 8 18H16C19.314 18 22 15.314 22 12C22 8.686 19.314 6 16 6ZM16 15C14.343 15 13 13.657 13 12C13 10.343 14.343 9 16 9C17.657 9 19 10.343 19 12C19 13.657 17.657 15 16 15Z'
          fill='#465364'
        />
      </g>
    </svg>
  );
}

export default ToggleIcon;
